<header class="appheader">
  <div class="appheader-inner">
    <!-- Logo -->
    <ls-logo size="sm" [href]="'/' + getLangValue()" />

    <!-- Nav principale (desktop) -->
    <nav class="appheader-nav" [attr.aria-label]="'HEADER.NAV_LABEL' | translate">
      @for (link of navLinks; track link.path + link.pathId) {
        @if(link.pathId===''){
          <a [routerLink]="['/', getLangValue(), link.path]" routerLinkActive="active">{{
            navKey(link) ? (navKey(link)! | translate) : link.label
          }}</a>
        } @else{
          <a [routerLink]="['/', getLangValue(), link.path, link.pathId]" routerLinkActive="active">{{
            navKey(link) ? (navKey(link)! | translate) : link.label
          }}</a>
        }
      }
    </nav>

    <!-- Recherche avec autocomplétion (cachée sur l'accueil tant que la barre du héros est visible, et sur les pages hideSearchOn) -->
    @if (showSearch) {
      <div class="appheader-search">
        <ls-search-box
          variant="compact"
          [placeholder]="'HEADER.SEARCH_PLACEHOLDER' | translate"
          [ariaLabel]="'HEADER.SEARCH_LABEL' | translate" />
      </div>
    }

    <!-- Actions droite -->
    <div class="appheader-right">
      <!-- Mobile : la loupe ouvre un panneau de recherche plein écran -->
      @if (showSearch) {
        <button
          class="appheader-icon-btn appheader-mobile-search"
          type="button"
          (click)="mobileSearchOpen.set(true)"
          [attr.aria-label]="'SEARCH_AC.OPEN' | translate"
          data-testid="header-mobile-search">
          <i class="ls-ic ls-search ic-20" aria-hidden="true"></i>
        </button>
      }

      @if (authService.isAuthenticated()) {
        <app-notification-bell />
      } @else {
        <button class="appheader-btn-ghost" type="button" (click)="login()">{{ 'HEADER.LOGIN' | translate }}</button>
        <a class="appheader-btn-primary" [routerLink]="['/', getLangValue(), routeName.GetStarted]"
          >{{ 'HEADER.GET_STARTED' | translate }}</a
        >
      }

      <!-- Pastille ☰ + avatar : navigation (≤ 1024 px), compte, thème et langue — remplace l'ancien hamburger
           et le sélecteur de thème séparé. Un seul bloc @if/@else pour la cloche et les boutons de connexion
           (deux @if indépendants peuvent laisser les deux branches dans le DOM après l'hydratation SSR). -->
      <ls-avatar-menu [navItems]="navItems()" (loginRequested)="login()" />
    </div>
  </div>

</header>

<!-- Panneau de recherche mobile (hors du <header> : son backdrop-filter piégerait le position: fixed) -->
@if (mobileSearchOpen()) {
  <div class="appheader-search-overlay" role="dialog" aria-modal="true" [attr.aria-label]="'SEARCH_AC.OPEN' | translate">
    <div class="appheader-search-overlay-bar">
      <ls-search-box
        class="appheader-search-overlay-box"
        variant="overlay"
        [autofocus]="true"
        [placeholder]="'HEADER.SEARCH_PLACEHOLDER' | translate"
        [ariaLabel]="'HEADER.SEARCH_LABEL' | translate"
        (done)="mobileSearchOpen.set(false)" />
      <button class="appheader-search-overlay-cancel" type="button" (click)="mobileSearchOpen.set(false)">
        {{ 'SEARCH_AC.CANCEL' | translate }}
      </button>
    </div>
  </div>
}
